<template>
    <div class="w-full ml-2">
        <UDropdownMenu :items="dropdown" :ui="{ content: 'w-full', width: 'w-52' }">
            <div
                class="flex gap-2 items-center group transition hover:text-primary-500 bg-gray-200/50 w-full p-1 rounded-lg border-gray-300 border cursor-pointer">
                <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                    <Icon :name="activeDropdown.icon" />
                </div>
                <span class="whitespace-nowrap text-sm font-bold">{{ activeDropdown.title }}</span>
                <Icon name="heroicons:chevron-down-16-solid" class="ml-auto" />
            </div>
            <template #item="{ item }">
                <div class="flex gap-2 items-center group transition hover:text-primary-500 rounded-lg cursor-pointer">
                    <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                        <Icon :name="item.icon" />
                    </div>
                    {{ item.title }}
                </div>
            </template>
        </UDropdownMenu>
    </div>
    <div v-if="activeDropdown.title === 'Pathway Framework'"
        class="flex flex-col gap-2 py-1.5 text-sm font-medium pl-4">
        <nuxt-link to="/developers/user-guide/introduction/welcome"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500"
            :class="{ 'active': $route.path.includes(`/developers/user-guide`) && !route.path.includes('/developers/user-guide/development/get-help') && !route.path.includes('/developers/user-guide/llm-xpack') && !route.path.includes('/developers/user-guide/connect') }">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:cpu-chip-16-solid" />
            </div>
            Developer Guide
        </nuxt-link>
        <nuxt-link to="/developers/user-guide/connect/pathway-connectors"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500"
            :class="{ 'active': $route.path.includes(`/developers/user-guide/connect`) }">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:arrows-right-left-16-solid" />
            </div>
            Connectors
        </nuxt-link>
        <nuxt-link to="/developers/user-guide/llm-xpack/overview"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500"
            :class="{ 'active': $route.path.includes(`/developers/user-guide/llm-xpack`) }">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:document-magnifying-glass" />
            </div>
            LLM and RAG Pipelines
        </nuxt-link>
        <nuxt-link to="/developers/api-docs/pathway"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500"
            :class="{ 'active': $route.path.includes(`/developers/api-docs`) }">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:code-bracket-16-solid" />
            </div>
            API Docs
        </nuxt-link>
        <nuxt-link to="/developers/user-guide/development/get-help"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500"
            :class="{ 'active': $route.path.includes(`/developers/user-guide/development/get-help`) }">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:lifebuoy-solid" />
            </div>
            Get help
        </nuxt-link>
    </div>
    <div v-if="activeDropdown.title === 'Pathway Templates'"
        class="flex flex-col gap-2 py-1.5 text-sm font-medium pl-4">
        <nuxt-link to="/developers/templates?tab=ai-pipelines"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500"
            :class="{ 'active': $route.path === '/developers/templates' && ($route.query.tab === undefined || $route.query.tab === 'ai-pipelines') }">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:document-magnifying-glass" />
            </div>
            RAG Templates
        </nuxt-link>
        <nuxt-link to="/developers/templates?tab=live-data-framework"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500"
            :class="{ 'active': $route.path === '/developers/templates' && ($route.query.tab === 'live-data-framework') }">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:cpu-chip-16-solid" />
            </div>
            ETL Templates
        </nuxt-link>
        <nuxt-link to="/developers/templates/run-a-template"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500"
            :class="{ 'active': $route.path === (`/developers/templates/run-a-template`) }">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:play-16-solid" />
            </div>
            Run a Template
        </nuxt-link>
        <nuxt-link to="/developers/user-guide/development/get-help"
            class="bg-gray-100 p-1 rounded-lg  flex gap-2 items-center group transition hover:text-primary-500">
            <div class="p-2 bg-gray-200 rounded-lg font-base group-hover:bg-primary-100 transition">
                <Icon name="heroicons:lifebuoy-solid" />
            </div>
            Get help
        </nuxt-link>
    </div>
    <div class="ml-4 py-2">
        <span class="text-sm font-bold">{{ currentNavTitle }}</span>
    </div>
</template>

<script setup>
const mapUrlNames = {
    "/developers/user-guide": "User Guide",
    "/developers/ai-pipelines": "AI Pipelines",
    "/developers/templates": "",
    "/developers/tutorials": "Tutorials",
    "/developers/api-docs": "API Docs"
}
const currentNavTitle = ref("")
const route = useRoute()
const getCurrentNavTitle = () => {
    return mapUrlNames[route.path.split("/").slice(0, 3).join("/")]
}

const dropdown = [
    [{
        title: "Pathway Framework",
        icon: "heroicons:cpu-chip-16-solid",
        onClick: () => {
            activeDropdown.value = dropdown[0][0]
            return navigateTo('/developers/user-guide/introduction/welcome')
        }
    }],
    [{
        title: "Pathway Templates",
        icon: "heroicons:bolt-16-solid",
        onClick: () => {
            activeDropdown.value = dropdown[1][0]
            return navigateTo('/developers/templates')

        }
    }]
]
const activeDropdown = ref(route.path.includes('/developers/templates') ? dropdown[1][0] : dropdown[0][0])
onMounted(() => {
    currentNavTitle.value = getCurrentNavTitle()
})
</script>

<style scoped lang="scss">
.active {
    color: var(--colors-primary-500);

    & div {
        background-color: var(--colors-primary-100);
    }
}
</style>
